export function maybeGetDocument() {
    if (typeof document === 'object') {
        return document;
    }
    return undefined;
}
export function maybeGetGlobal() {
    if (typeof self === 'object') {
        return self;
    }
    else {
        return global;
    }
}
//# sourceMappingURL=globals.js.map